export default __webpack_public_path__ + "static/media/Promotional_XP.fe207fb7.png";